module.exports = __webpack_public_path__ + "img/ac8.990b1d19.jpg";